import React from 'react';
import Button from '../atoms/Button';
import PlusIcon from '../atoms/PlusIcon';
import { Heading1, BodyText } from '../atoms/Typography';

/**
 * Page header organism — title, description, primary CTA.
 */
export default function PageHeader({
  title = 'Complaint Management',
  description,
  actionLabel = 'Create New Form',
  onAction,
  className = '',
}) {
  return (
    <header className={`ca-page-header ${className}`.trim()}>
      <div className="ca-page-header__text">
        <Heading1>{title}</Heading1>
        {description ? <BodyText>{description}</BodyText> : null}
      </div>
      <div className="ca-page-header__actions">
        <Button startIcon={<PlusIcon />} onClick={onAction}>
          {actionLabel}
        </Button>
      </div>
    </header>
  );
}
